import React, { useEffect, useState } from 'react';
import './TransferSection.scss';
import Select from "react-select/base";
import {formatCurrency, formatDestinationAccountType, formatSortCode} from "../../../../../utils/helpers";
import TextInput from "../../../../Form/TextInput/TextInput";
import {CustomSelect} from "../../../../Form/Select/Select";

/** @import {OtherAccount, TransferSectionProps} from './TransferSectionTypes' */
function TransferSection(/** @type {TransferSectionProps} */ {
    accountList,
    maturingAccount,
    selectedAccount,
    setSelectedAccount,
    transferInputValue, 
    selectedProduct
}) {

    const [displayDropdown] = useState(accountList ? accountList.length > 1 : false);
    const [selectedPayawayDestinationAccount, setSelectedPaywayDestinationAccount] = useState(/** @type {OtherAccount | null | undefined} */ (null));
    
    useEffect(() => {
        //setSelectedAccount(accountList && accountList.length > 0 ? accountList[0] : undefined);
        setInstructionOnLoad();
    }, [displayDropdown, accountList, selectedAccount]);

    const setInstructionOnLoad = () => {
        setSelectedPaywayDestinationAccount(selectedAccount);
    }
    
    const renderSelectedDestinationAccountDetails = (/** @type {OtherAccount} */ payawayDestinationAccount) => {
        
        if (!payawayDestinationAccount) return null;

        if (payawayDestinationAccount.product.name === "Linked Account") {
            return (
                <>
                    <div
                        className="maturity3__narrow-box-max-width maturity3__emphasis-box maturity3__emphasis-box--blue maturity3__emphasis-box--narrow maturity3__grid mb-2">

                    <div>Sort code:</div>
                        <div><b>{formatSortCode(payawayDestinationAccount.sortCode)}</b></div>
                        <div>Account number:</div>
                        <div><b>{payawayDestinationAccount.accountNumber}</b></div>
                    </div>
                </>)
        }
        else 
        return (
            <div
                className="maturity3__narrow-box-max-width maturity3__emphasis-box maturity3__emphasis-box--blue maturity3__emphasis-box--narrow maturity3__grid mb-2">
                <div>
                    Account number: <strong>{payawayDestinationAccount.accountNumber}</strong><br/>
                    Balance: <strong>{formatCurrency(payawayDestinationAccount.balance)}</strong>
                </div>
            </div>
        );
    };
    const renderDestinationAccountDropDown = (/** @type {OtherAccount[]} */ accountList) => {
        const mapAccountDropDown = (/** @type {OtherAccount[]} */ accountList) => {
            return accountList.map((account) => {
                return {
                    "label": `${account.product.name} - ${account.accountNumber}`,
                    "value": account.accountNumber
                };
            });
        };
        const onSelect = (/** @type {string} */ selectedAccountNumber) => {
            const account = accountList.find(a => a.accountNumber === selectedAccountNumber);
            if (account) {
                setSelectedAccount(account);
                setSelectedPaywayDestinationAccount(account);
            }
        };

        return <>
            <CustomSelect
                name="account"
                placeholder="Select the account"
                options={mapAccountDropDown(accountList)}
                onChange={option => option && onSelect(option.value)}
                isDisabled={transferInputValue <= 0 || selectedProduct === undefined || (Number(maturingAccount?.balance) - Number(transferInputValue)) < 5000 }
                //@ts-expect-error not sure how to handle this from a typescript perspective
                value={selectedPayawayDestinationAccount ? mapAccountDropDown([selectedPayawayDestinationAccount]) : null}
            />
            {selectedPayawayDestinationAccount && renderSelectedDestinationAccountDetails(selectedPayawayDestinationAccount)}
        </>;
    };

    return (
        <div className={"transferSection"}>
            <span className={"section_Title"}>Transfer amount</span>
            <div className={"transferAmount"}>
                <TextInput
                    className="my-account__input"
                    value={formatCurrency(transferInputValue)}
                    label='You’ll be transferring'
                    disabled
                />
                <div className={"text-input__wrapper"}>
                    <label className={"text-input__label"}>Where would you like the transfer to go?</label>
                    <div className='maturity3__flex-row--equal-width-child-max-width'>
                        {accountList && renderDestinationAccountDropDown(accountList)}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TransferSection;